import { CampaignBidPrice } from 'core/campaignBidPrice/CampaignBidPrice';
import { AxiosInstance } from 'axios';
import client from './RestClient';

export interface CampaignBidPriceWebService {
  getDefaultCampaignBidPrices (): Promise<CampaignBidPrice[]>;
}

export class RestfulCampaignBidPriceWebService implements CampaignBidPriceWebService {
  restClient: AxiosInstance;

  constructor (restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getDefaultCampaignBidPrices (): Promise<CampaignBidPrice[]> {
    const response = await this.restClient.get('/campaign-bid-prices');
    return response.data.records;
  }
}
